import { ContentPage } from '../page-factory/content-page';
import { camp67AndTheLandPage } from '../pages/page-the-camp.camp67-and-the-land';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(camp67AndTheLandPage);

export default function Camp67AndTheLandPage() {
  return <ContentPage {...camp67AndTheLandPage} />;
}
